import React from 'react';
import BlogPost from '../../../../components/util/RenderBlogPosts/RenderBlogPosts';
import { ResourcePageProps } from '../../../../pages/resources/[resourcePage]';
import DefaultWidthContainer from '../../../Layout/Containers/DefaultWidthContainer';
import LargeWidthContainer from '../../../Layout/Containers/LargeWidthContainer';
import { StrapiImageComponent } from '../../../util/MediaComponent/MediaComponent';
import PageHeaderComponent from '../../../util/PageHeader/PageHeaderComponent';
import SocialMediaLinks from '../../../util/SocialMediaLinks/SocialMediaLinks';
import ResourceComponent, { GetAuthorText } from '../ResourceComponent';
import styles from './resourcePage.module.scss';
import TripleColumnContainer from '../../../Layout/Containers/TripleColumnContainer';

const ResourcePageComponent = ({ resource, resources }: ResourcePageProps) => {
    const renderRelatedArticles = () => {
        if (resources.length < 0) {
            return null;
        } else {
            return (
                <div className={styles.relatedProjectsContainer}>
                    <LargeWidthContainer>
                        <h2 className={styles.h2}>Related articles</h2>
                    </LargeWidthContainer>
                    <TripleColumnContainer>
                        {resources
                            .filter((resource, index) => index < 3) // Just the first two items
                            .filter(
                                (resourceFilter, index) => resourceFilter.seoUrl !== resource.seoUrl
                            ) // Filter self
                            .map((relatedResource) => (
                                <ResourceComponent
                                    key={`related-resource-${relatedResource.seoUrl}`}
                                    mainImage={relatedResource.mainImage}
                                    heading={relatedResource.heading}
                                    ingress={relatedResource.ingress}
                                    resource_category={relatedResource.resource_category}
                                    seoUrl={relatedResource.seoUrl}
                                    authorName={relatedResource.authorName}
                                    publishedAt={relatedResource.publishedAt}
                                    linearLayout={true}
                                />
                            ))}
                    </TripleColumnContainer>
                </div>
            );
        }
    };

    return (
        <>
            <PageHeaderComponent heading={resource.heading}>
                <h1>{resource.ingress}</h1>
            </PageHeaderComponent>
            <DefaultWidthContainer extraClassNames={styles.smallText}>
                <GetAuthorText
                    authorName={resource.authorName}
                    publishedAt={resource.publishedAt}
                />
            </DefaultWidthContainer>
            <LargeWidthContainer extraStyles={{ paddingBottom: '32px' }}>
                <SocialMediaLinks url={`www.noria.no/resources/${resource.seoUrl}`} />
                <div className={styles.centerImage}>
                    <StrapiImageComponent
                        maxWidth={1644}
                        maxHeight={924}
                        strapiImage={resource.mainImage}
                    />
                </div>
            </LargeWidthContainer>
            <BlogPost blog={resource} />
            {renderRelatedArticles()}
        </>
    );
};

export default ResourcePageComponent;
